import { IStore, IFetchResult, IFetchRequest } from './store.interface';
import axios from 'axios';
import { BaseService } from '@/features/base/api/base.api';

class StoreService extends BaseService {
  private static instance: StoreService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public all(): Promise<IApi<IStore[]>> {
    return this.get<IStore[]>(`${this.baseUrl}/api/stores`);
  }

  public add(store: IStore): Promise<IApi<IStore>> {
    return this.postItem<IStore>(`${this.baseUrl}/api/stores`, store);
  }

  public update(store: IStore): Promise<IApi<IStore>> {
    return this.putItem<IStore>(`${this.baseUrl}/api/stores/${store.id}`, store);
  }

  public delete(id: number): Promise<IApi<number>> {
    return this.deleteItem<number>(`${this.baseUrl}/api/stores/${id}`);
  }

  public fetchAll(stores: IStore[]): Promise<IApi<IFetchResult[]>[]> {
    const self = this;
    const promises = stores.map(s => self.get<IFetchResult[]>(`${this.baseUrl}/api/stores/${s.id}/download/sales`));
    return Promise.all(promises);
  }

  public status(jobIds: any[]): Promise<IApi<any[]>> {
    return this.postItem<any>(`${this.baseUrl}/api/stores/jobs/status`, { jobIds });
  }
}

export const storeService = StoreService.Instance;
